export default function Sidebar() {
  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <ul className="nav">
        <li className="nav-item nav-profile">

        </li>
        <li className="nav-item">
          <a className="nav-link" href="/dashboard">
            <span className="menu-title">Dashboard</span>
            <i className="mdi mdi-home menu-icon" />
          </a>
        </li>

        <li className="nav-item">
          <a className="nav-link" href="/orders">
            <span className="menu-title">Orders</span>
            <i className="mdi mdi-contacts menu-icon" />
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/products">
            <span className="menu-title">Products</span>
            <i className="mdi mdi-format-list-bulleted menu-icon" />
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/users">
            <span className="menu-title">Users</span>
            <i className="mdi mdi-contacts menu-icon" />
          </a>
        </li>

        <li className="nav-item">
          <a className="nav-link" href="/settings">
            <span className="menu-title">Settings</span>
            <i className="mdi mdi-settings menu-icon" />
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#">
            <span className="menu-title">Tables</span>
            <i className="mdi mdi-table-large menu-icon" />
          </a>
        </li>

      </ul>
    </nav>
  )
}
